import theme from "@/theme";

export const stylesCoinRow = {
  coinRow: {
    height: "64px",
    cursor: "pointer",
  },
  tableCell: {
    backgroundColor: "#FFFFFF",
    padding: 0,
    height: "64px",
    border: "none",
  },
  nameCellBox: {
    display: "flex",
    alignItems: "center",
    padding: "0 0 0 24px",
    width: "280px",
    height: "64px",
    gap: 1.5,
  },
  CellBox: {
    display: "flex",
    alignItems: "center",
    padding: "0 0 0 24px",
    width: "140px",
    height: "64px",
  },
  CellBoxIcon: {
    display: "flex",
    alignItems: "center",
    padding: "0",
    height: "64px",
    justifyContent: "center",
  },
  CellBoxIconStar: {
    width: "174px",
  },
  CellBoxIconRemoe: {
    width: "132px",
  },
  nameText: {
    fontWeight: "500",
    maxWidth: "190px",
  },
  priceText: {
    fontSize: "14px",
    fontWeight: "500",
  },
  symbolText: {
    fontSize: "12px",
    color: "#76839b",
    fontWeight: "500",
  },
  sentimentIconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "64px",
  },
  bearIcon: {
    width: "27px",
    height: "15px",
  },
  bullIcon: {
    width: "24px",
    height: "14px",
  },
  sentimentBox: (color: string) => ({
    display: "flex",
    alignItems: "center",
    color: color,
    width: "82px",
    height: "30px",
    angle: "0 deg",
    opacity: 1,
    paddingTop: "4px",
    paddingRight: "8px",
    paddingBottom: "4px",
    paddingLeft: "8px",
    gap: "7px",
  }),
  sentimentText: {
    width: "32px",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontStyle: "Medium",
    fontSize: "14px",
    lineHeight: "22px",
    letterSpacing: "0%",
    textAlign: "center",
  },
  postsText: {
    color: "#2A2D31",
    fontSize: "14px",
    fontWeight: "500",
  },
  like: {
    display: "flex",
    alignItems: "center",
    color: "#FF403D",
    mr: 1,
  },
  likeText: {
    color: "#2A2D31",
    fontSize: "14px",
    fontWeight: "500",
  },
  starButton: {
    color: theme.palette.custom.mainBlue,
  },
  icon: {
    margirLeft: "24px",
    height: "40px",
    width: "40px",
  },
};
